function getURLVar(key) {
  var value = [];

  var query = String(document.location).split("?");

  if (query[1]) {
    var part = query[1].split("&");

    for (i = 0; i < part.length; i++) {
      var data = part[i].split("=");

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return "";
    }
  }
}

var _learnq = _learnq || [];

$(document).ready(function () {
  $("body").css({ visibility: "visible" });

  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function (e) {
    var id = $(this).attr("href").substr(1);
    var offset = 0;

    if ($(this).data("offset")) {
      offset = $(this).data("offset");
    }

    var pos = $("#" + id).offset().top - $("nav#main-nav").height() - offset;
    $("html,body").animate({ scrollTop: pos });
    e.preventDefault();
  });

  $(document).on("change", ".custom-file-input", function (e) {
    var fileName = this.files[0].name;
    var nextSibling = e.target.nextElementSibling;
    nextSibling.innerText = fileName;
  });

  // Highlight any found errors
  $(".text-danger").each(function () {
    var element = $(this).parent().parent();

    if (element.hasClass("form-group")) {
      element.addClass("has-error");
    }
  });

  // Currency
  $("#form-currency .currency-select").on("click", function (e) {
    e.preventDefault();

    $("#form-currency input[name='code']").val($(this).attr("name"));

    $("#form-currency").submit();
  });

  // Language
  $("#form-language .language-select").on("click", function (e) {
    e.preventDefault();

    $("#form-language input[name='code']").val($(this).attr("name"));

    $("#form-language").submit();
  });

  /* Search */
  $("#search input[name='search']")
    .parent()
    .find("a")
    .on("click", function () {
      var url = $("base").attr("href") + "index.php?route=product/search";

      var value = $("header #search input[name='search']").val();

      if (value) {
        url += "&search=" + encodeURIComponent(value);
      }

      location = url;
    });

  $("#search input[name='search']").on("keydown", function (e) {
    if (e.keyCode == 13) {
      $("header #search input[name='search']")
        .parent()
        .find("a")
        .trigger("click");
    }
  });

  // Menu
  $("#menu .dropdown-menu").each(function () {
    var menu = $("#menu").offset();
    var dropdown = $(this).parent().offset();

    var i =
      dropdown.left +
      $(this).outerWidth() -
      (menu.left + $("#menu").outerWidth());

    if (i > 0) {
      $(this).css("margin-left", "-" + (i + 10) + "px");
    }
  });

  // Checkout
  $(document).on(
    "keydown",
    "#collapse-checkout-option input[name='email'], #collapse-checkout-option input[name='password']",
    function (e) {
      if (e.keyCode == 13) {
        $("#collapse-checkout-option #button-login").trigger("click");
      }
    }
  );

  // tooltips on hover
  $("[data-toggle='tooltip']").tooltip({ container: "body" });

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function () {
    $("[data-toggle='tooltip']").tooltip({ container: "body" });
  });

  //Product Datalayer
  var productObj = {};
  $(".datalayer-click,.datalayer-onlyclick").click(function (event) {
    if ($(this).data("id") && $(this).data("name")) {
      dataLayer.push({
        event: "reset",
        ecommerce: undefined,
      });
      event.preventDefault();
      productObj["url"] = $(this).attr("href");
      productObj["id"] = $(this).data("id");
      productObj["name"] = $(this).data("name");
      productObj["brand"] = "House Of Worktops";
      productObj["price"] = $(this).data("price").substring(1);
      productObj["cat"] = $(this).data("cat");
      pushtodaalayer(productObj);
    }
  });

  //Add Oiling.

  $(".datalayer-oiling").click(function (event) {
    if ($(this).data("id") && $(this).data("name")) {
      dataLayer.push({
        event: "reset",
        ecommerce: undefined,
      });
      // event.preventDefault();
      dataLayer.push({
        event: $(this).data("label"),
        ecommerce: {
          currencyCode: "GBP",
          add: {
            oiling: [
              {
                name: $(this).data("name"),
                id: $(this).data("id"),
                location: $(this).data("location"),
                label: $(this).data("label"),
              },
            ],
          },
        },
      });
    }
  });

  //value-stacking.

  $(".value-stacking-datalayer").click(function (event) {
    if ($(this).data("id") && $(this).data("name")) {
      dataLayer.push({
        event: "reset",
        ecommerce: undefined,
      });
      // event.preventDefault();
      dataLayer.push({
        event: $(this).data("label"),
        advertisement: {
          "value-stacking": [
            {
              name: $(this).data("name"),
              id: $(this).data("id"),
              location: $(this).data("location"),
              label: $(this).data("label"),
            },
          ],
        },
      });
    }
  });

  function pushtodaalayer(productObj) {
    dataLayer.push({
      event: "productClick",
      ecommerce: {
        click: {
          actionField: { list: document.title.split("|")[0].trim() + " Page" }, // Optional list property.
          products: [
            {
              name: productObj.name, // Name or ID is required.
              id: productObj.id,
              price: parseFloat(productObj.price),
              category: productObj.cat,
              brand: "House of Worktops",
            },
          ],
        },
      },
    });
    document.location = productObj.url;
  }

  function getImpressions() {
    var pageObj = new Array();
    $(".datalayer-click,.datalayer-onlyclick").each(function (i, k) {
      var item = {};
      item["id"] = $(this).data("id");
      item["name"] = $(this).data("name");
      item["price"] = $(this).data("price").replace(/^\D+/g, "");
      item["brand"] = "House of Worktops";
      item["category"] = $(this).data("cat");
      item["list"] = document.title.split("|")[0].trim() + " Page";
      item["position"] = i + 1;
      pageObj.push(item);
    });

    if (pageObj.length) {
      prodImpressions(pageObj);
    }
  }

  function prodImpressions(pageObj) {
    dataLayer.push({
      event: "productimpression",
      ecommerce: {
        currencyCode: "GBP", // Local currency is optional.
        impressions: pageObj,
      },
    });
    dataLayer.push({
      event: "reset",
      ecommerce: undefined,
    });
  }

  //Promotion Datalayer
  var query_mobile = 768;
  if ($(window).width() >= query_mobile) {
    $("#kitchen-home-banner a").addClass("datalayer-promotion-click");
    $("#oak-flooring-banner a").addClass("datalayer-promotion-click");
    $("#trade-partner-banner .shop-now > a").addClass(
      "datalayer-promotion-click"
    );
    $("#mega-savings-sale  a").addClass("datalayer-promotion-click");
    $("#price-drop-banner a").addClass("datalayer-promotion-click");
    // $(".april-sale-banner").addClass("datalayer-promotion-click");
    $(".general-worktop-banner").addClass("datalayer-promotion-click");
    $("#easter-sale-banner a").addClass("datalayer-promotion-click");
    $("#home-page-banner a").addClass("datalayer-promotion-click");
    $(".home-banner-slider .shop-now > a").addClass(
      "datalayer-promotion-click"
    );
    $(".promotion-banner .desktop > a").addClass("datalayer-promotion-click");
    $("#summer-sale-home-banner .summer-sale-banner__cta, #summer-sale-home-banner .summer-sale-banner__product-link").addClass("datalayer-promotion-click");
    $("#autumn-sale-banner a").addClass("datalayer-promotion-click");
    $("#black-friday-sale-banner a").addClass("datalayer-promotion-click");
    $("#general-worktop-banner a").addClass("datalayer-promotion-click");
    $("#winter-sale-banner a").addClass("datalayer-promotion-click");
    $("#feb-sale-banner a").addClass("datalayer-promotion-click");
    $("#oiling-kit a").addClass("datalayer-promotion-click");
    $(".worktop-banner").addClass("datalayer-promotion-click");
    $(".worktop-summer-banner").addClass("datalayer-promotion-click");
    $(".nov-sale-banner").addClass("datalayer-promotion-click");
    $(".jan-sale-banner").addClass("datalayer-promotion-click");
    $(".feb-sale-banner").addClass("datalayer-promotion-click");
    $(".black-friday-banner").addClass("datalayer-promotion-click");
    $(".christmas-worktop-banner").addClass("datalayer-promotion-click");
    
  } else if ($(window).width() < 768) {
    $("#oak-flooring-banner a").addClass("datalayer-promotion-click");
    $("#trade-partner-banner .shop-now > a").addClass(
      "datalayer-promotion-click"
    );
    $(".nov-sale-banner").addClass("datalayer-promotion-click");
    $(".jan-sale-banner").addClass("datalayer-promotion-click");
    $(".feb-sale-banner").addClass("datalayer-promotion-click");
    $(".black-friday-banner").addClass("datalayer-promotion-click");
    $("#mega-savings-sale  a").addClass("datalayer-promotion-click");
    $("#price-drop-banner a").addClass("datalayer-promotion-click");
    // $(".april-sale-banner").addClass("datalayer-promotion-click");
    $(".general-worktop-banner").addClass("datalayer-promotion-click");
    $("#easter-sale-banner a").addClass("datalayer-promotion-click");
    $("#home-page-banner a").addClass("datalayer-promotion-click");
    $("#summer-sale-home-banner .summer-sale-banner__cta, #summer-sale-home-banner .summer-sale-banner__product-link").addClass("datalayer-promotion-click");
    $("#autumn-sale-banner a").addClass("datalayer-promotion-click");
    $("#black-friday-sale-banner a").addClass("datalayer-promotion-click");
    $("#general-worktop-banner a").addClass("datalayer-promotion-click");
    $(".christmas-worktop-banner").addClass("datalayer-promotion-click");
    $(".promotion-banner .shop-now > a").removeClass(
      "datalayer-promotion-click"
    );
    $(".promotion-banner .desktop > a").removeClass(
      "datalayer-promotion-click"
    );
    $(".home-banner-mobile-text .promotion-data").addClass(
      "datalayer-promotion-click"
    );
    $("#winter-sale-banner a").addClass("datalayer-promotion-click");
    $("#feb-sale-banner a").addClass("datalayer-promotion-click");
    $(".promotion-banner .mobile > a").addClass("datalayer-promotion-click");
    $("#oiling-kit a").addClass("datalayer-promotion-click");
    $(".worktop-banner").addClass("datalayer-promotion-click");
    $(".worktop-summer-banner").addClass("datalayer-promotion-click");
    // $('.home-banner-image-mobile > a').addClass('datalayer-promotion-click');
  }
  var promotionObj = {};
  $(".datalayer-promotion-click, .datalayer-promotion").click(function (event) {
    if ($(this).data("id") && $(this).data("name")) {
      dataLayer.push({
        event: "reset",
        ecommerce: undefined,
      });
      event.preventDefault();
      promotionObj["url"] = $(this).attr("href");
      promotionObj["id"] = $(this).data("id");
      promotionObj["name"] = $(this).data("name");
      pushtopromodatalayer(promotionObj);
    }
  });

  function pushtopromodatalayer(promotionObj) {
    dataLayer.push({
      event: "promotionClick",
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: promotionObj.id,
              name: promotionObj.name,
            },
          ],
        },
      },
    });
    // banner select promotion event
    dataLayer.push({
      event: "select_promotion",
      ecommerce: {
        creative_name: promotionObj.name,
        creative_slot: promotionObj.id,
        promotion_id: promotionObj.id,
        promotion_name: promotionObj.name,
        items: [
          {
            item_id: promotionObj.id,
            item_name: promotionObj.name,
          },
        ],
      },
    });
    document.location = promotionObj.url;
  }

  var count = 0;
  function getPromotionImpressions() {
    var promoObj = new Array();
    $(".datalayer-promotion-click").each(function (i, k) {
      var item = {};
      item["id"] = $(this).data("id");
      item["name"] = $(this).data("name");
      item["creative_slot"] = $(this).data("id");
      item["creative_name"] = $(this).data("name");
      item["item_id"] = $(this).data("id");
      item["item_name"] = $(this).data("name");
      item["position"] = i + 1;
      promoObj.push(item);
      count++;
    });

    if (promoObj.length) {
      promotionImpressions(promoObj);
    }
  }

  function promotionImpressions(promoObj) {
    dataLayer.push({
      event: "promotionimpression",
      ecommerce: {
        promoView: {
          promotions: promoObj,
        },
      },
    });
    dataLayer.push({
      event: "view_promotion",
      ecommerce: promoObj,
    });
    dataLayer.push({
      event: "reset",
      ecommerce: undefined,
    });
  }

  //Exitpopup Datalayer
  var exitpopupQuery = 768;
  if ($(window).width() < exitpopupQuery) {
    $(".exit-popup , .exit-popup-large").removeClass("exit-popup-datalayer");
    $(".exit-popup-mobile").addClass("exit-popup-datalayer");
  } else {
    $(".exit-popup-mobile").removeClass("exit-popup-datalayer");
    $(".exit-popup-oak , .exit-popup-large").addClass("exit-popup-datalayer");
  }
  var exitpopupClickObj = {};
  $(".exit-popup-click").click(function (event) {
    event.preventDefault();
    exitpopupClickObj["label"] = $(this).data("label");
    exitpopupClickObj["url"] = $(this).attr("href");
    pushtoExitpopupDataLayer(exitpopupClickObj);
  });

  function pushtoExitpopupDataLayer(exitpopupClickObj) {
    dataLayer.push({
      event: "clickedExitPopup",
      category: "userinteraction",
      action: "clickedExitPopup",
      label: exitpopupObj.label + "-" + exitpopupClickObj.label,
    });
    document.location = exitpopupClickObj.url;
  }

  var exitpopupObj = {};
  function getExitpopupImpressions() {
    $(".exit-popup-datalayer").each(function () {
      exitpopupObj["label"] = $(this).data("label");
      exitpopupImpressions(exitpopupObj);
    });
  }

  function exitpopupImpressions(exitpopupObj) {
    dataLayer.push({
      event: "exitpopupimpression",
      category: "userInteraction",
      action: "exitpopupimpression",
      label: exitpopupObj.label,
    });
  }

  //Email Popout Datalayer
  var emailPopupObj = {};
  $(".email-popup-click").click(function () {
    emailPopupObj["label"] = $(this).data("label");
    // console.log(validateEmail($('.emailId').val()));
    if (
      validateEmail($(".emailField").val()) ||
      validateEmail($(".emailId").val())
    ) {
      // console.log(emailPopupObj);
      pushtoEmailPopupDatalayer(emailPopupObj);
      pushEmailToService($(".emailField").val());
    }
    // console.log(emailPopupObj);
  });

  $(".email-popup-click-close").click(function () {
    emailPopupObj["label"] = $(this).data("label");
    pushtoEmailPopupDatalayer(emailPopupObj);
  });

  var prodData = $(".prodDatascpature").last().data("prod");

  $(".email-click").click(function () {
    var email = $(this).closest(".newsForm").find(".emailField").val();

    // global user data object
    var currentUserData = JSON.parse(localStorage.getItem("userData")) || [];
    var userData = { email: email };

    if (!currentUserData) {
      localStorage.setItem("userData", JSON.stringify(userData));
    } else {
      localStorage.setItem(
        "userData",
        JSON.stringify({ ...currentUserData, ...userData })
      );
    }

    if (validateEmail(email)) {
      dataLayer.push({
        event: "clickedCheckoutPopup",
        category: "userInteraction",
        action: "clickedCheckoutPopup",
        label: $(this).data("label"),
      });
    }
  });

  $(".proceed-checkoutnow").click(function () {
    dataLayer.push({
      event: "clickedCheckoutPopup",
      category: "userInteraction",
      action: "clickedCheckoutPopup",
      label: $(this).data("label"),
    });
  });

  function pushtoEmailPopupDatalayer(emailPopupObj) {
    dataLayer.push({
      event: "clickedEmailPopup",
      category: "userInteraction",
      action: "clickedEmailPopup",
      label: emailPopupObj.label,
    });
  }

  function pushEmailToService(email) {
    _learnq.push(["identify", { $email: email }]);
  }

  getExitpopupImpressions();
  getPromotionImpressions();
  getImpressions();

  //oiling Kit
  // $(".offer-popup-label").css("display", "flex");
  // $("#offers-popup").click(function () {
  //   $(".offers-sidepanel .sidepanel-overlay").addClass("active");
  //   $(".offers-sidepanel .sidepanel-card").addClass("active");
  //   $("body").addClass("no-scroll");
  // });

  $(".close-btn").click(function () {
    $(".offers-sidepanel .sidepanel-overlay").removeClass("active");
    $(".offers-sidepanel .sidepanel-card").removeClass("active");
    $("body").removeClass("no-scroll");
  });

  // $(".offers-sidepanel .sidepanel-overlay").click(function () {
  //   $("#nav_offer").removeClass("active");
  //   $(".offers-sidepanel .sidepanel-overlay").removeClass("active");
  //   $(".offers-sidepanel .sidepanel-card").removeClass("active");
  //   $("body").removeClass("no-scroll");
  // });

  var active = false;

  function validateEmail(email) {
    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  var offer_id, offer_category_id;
  $(".oilingpanel").on("submit", function (e) {
    var _this = $(this);
    signUpButton.prop("disabled", true);
    var messageTypes = {
      0: "<span>Thank you for subscribing!</span>",
      1: "<span>Please check the email you have entered.</span>",
      2: "<span>An error has occured</span>",
      3: "<span>Thank you! Your subscription has been updated.</span>",
    };

    e.preventDefault();
    let field = $(this).find(".offer-email");
    offer_id = field.data("offer-id");
    let feedback = $(this).find(".feedback");
    offer_category_id = field.data("offer-category-id");

    field.removeClass("is-invalid is-valid");
    feedback.empty().removeClass("text-danger text-secondary");

    let data = field.val();
    if (data == "") {
      field.addClass("is-invalid");
      feedback.html(messageTypes[1]).addClass("text-danger");
      signUpButton.prop("disabled", false);
      return;
    } else {
      _learnq.push([
        "identify",
        {
          $email: data,
        },
      ]);
    }

    if (!validateEmail(data)) {
      field.addClass("is-invalid");
      feedback.html(messageTypes[1]).addClass("text-danger");
      signUpButton.prop("disabled", false);
      return;
    }

    var totaler = 0;
    $.ajax({
      url: "index.php?route=promotion/offer/addOffer",
      type: "post",
      data: _this.serialize() + "&emailID=" + encodeURIComponent(data),
      dataType: "json",
      success: function (json) {
        console.log(json);
        if (json["error"]) {
          signUpButton.prop("disabled", false);
          field.addClass("is-invalid");
          feedback.html(messageTypes[json["error"]]).addClass("text-danger");
        }

        if (json["success"] || CookieService.getCookie("offer-claimed")) {
          var redirectCheck = _this.data("go");
          if (_this.find("input[name='offer_id']").val()) {
            let obj = {
              offer_id: offer_id,
              coupon_code: json.coupon_code,
              category_id: offer_category_id,
            };
            var offerclaimed = CookieService.getCookie("offer-claimed")
              ? [...JSON.parse(CookieService.getCookie("offer-claimed")), obj]
              : [obj];
            CookieService.setCookie(
              "offer-claimed",
              JSON.stringify(offerclaimed),
              1
            );
          }
          if (
            typeof redirectCheck !== typeof undefined &&
            redirectCheck !== false
          ) {
            location.href =
              _this.data("go") + "&email=" + encodeURIComponent(data);
          }

          _this
            .parents(".popup-form")
            .html(
              "<label for='copy_textarea' tabindex='-1' class=''></label><button class='btn border offer-click bg-white coupon-click-" +
                offer_id +
                " p-2 w-100' data-offer-id='" +
                offer_id +
                "'data-clipboard-target='coupon_click_" +
                offer_id +
                "' onclick='offerClick(this);' id='btn_copy_" +
                offer_id +
                "' data-label='hp-coupon-click'><div class='d-flex justify-content-between position-relative'><h6 class='pl-2 mb-0' value='' id='coupon_click_" +
                offer_id +
                "'>" +
                json.coupon_code +
                "</h6><img src='catalog/view/theme/houseofworktops/image/offer_popup/copy-icon 2.svg' class='img-fluid'><span id='copy_tooltip' aria-live='assertive' role='tooltip'></span></div></button><div class='text-center mb-2'><a href='" +
                window.location.origin +
                "/index.php?route=product/category&path=" +
                offer_category_id +
                "'  class='text-gray-900 text-underline'><small>View Product</small></a></div>"
            );

          if (json.total) {
            totaler = json.total;
            setTimeout(function () {
              $("#cart > button").html(
                '<img src = "catalog/view/theme/houseofworktops/image/svg-icons/cart.svg" title = "{{ name }}" alt = "{{ name }}" class= "img-responsive mb-1" width = "20" loading = "lazy"/><div class="d-xl-inline" ><span class="px-1">Cart</span><span id="cart-total" class="badge badge-danger rounded-circle"> ' +
                  totaler +
                  "</span></div></span>"
              );
              $("#cart > ul").load("index.php?route=common/cart/info ul li");
            }, 1000);
            return true;
          }
          field.addClass("is-valid");
          feedback
            .html(messageTypes[json.typeofupdate])
            .addClass("text-secondary");
        }
				if (CookieService.getCookie("offer-applied")) {
					let offerApplied = JSON.parse(
						CookieService.getCookie("offer-applied")
					);
					$(".offer-coupon")
					.parents(".popup-form")
					.html(
						"<label for='copy_textarea' tabindex='-1' class=''></label><button class='btn border offer-click bg-white coupon-click- p-2 w-100' data-offer-id='' data-clipboard-target='coupon_click_' onclick='offerClick(this);' id='btn_copy_' data-label='hp-coupon-click'><div class='d-flex justify-content-between position-relative'><h6 class='pl-2 mb-0' value='' id='coupon_click_'> FREE</h6><img src='catalog/view/theme/houseofworktops/image/offer_popup/copy-icon 2.svg' class='img-fluid'><span id='copy_tooltip' aria-live='assertive' role='tooltip'></span></div></button><div class='text-center mb-2'><a href='" +
							window.location.origin +
							"/index.php?route=product/category&path='  class='text-gray-900 text-underline'><small>View Product</small></a></div>"
					);
				}
      },
      error: function (xhr, ajaxOptions, thrownError) {
        field.addClass("is-invalid");
        feedback.html(messageTypes[2]).addClass("text-danger");
        signUpButton.prop("disabled", false);
        console.log(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
    const settings = {
      data: { $email: data },
    };
    $.ajax(settings).done(function (response) {
      _learnq.push(["track", "Applied Offer"]);
    });
  });

	$(".offer-coupon").on("submit", function (e) {
		e.preventDefault()
    var _this = $(this);
		let signUpButton = $(".btn-signup");
		signUpButton.prop("disabled", true);
		var messageTypes = {
			0: "<span>Thank you for subscribing!</span>",
			1: "<span>Please check the email you have entered.</span>",
			2: "<span>An error has occured</span>",
			3: "<span>Thank you! Your subscription has been updated.</span>",
		};
		let field = $(this).find(".offer-email");
		let feedback = $(this).find(".feedback");
		offer_category_id = field.data("offer-category-id");	

		field.removeClass("is-invalid is-valid");
		feedback.empty().removeClass("text-danger text-secondary");

	 	let data = field.val();
		if (data == "") {
			field.addClass("is-invalid");
			feedback.html(messageTypes[1]).addClass("text-danger");
			signUpButton.prop("disabled", false);
			return;
		} else {
			_learnq.push([
				"identify",
				{
					$email: data,
				},
			]);

			CookieService.setCookie('offer-applied', true , 10);
		}
	 	_this
			.parents(".popup-form")
			.html(
				"<label for='copy_textarea' tabindex='-1' class=''></label><button class='btn border offer-click bg-white coupon-click- p-2 w-100' data-offer-id='' data-clipboard-target='coupon_click_' onclick='offerClick(this);' id='btn_copy_' data-label='hp-coupon-click'><div class='d-flex justify-content-between position-relative'><h6 class='pl-2 mb-0' value='' id='coupon_click_'> FREE</h6><img src='catalog/view/theme/houseofworktops/image/offer_popup/copy-icon 2.svg' class='img-fluid'><span id='copy_tooltip' aria-live='assertive' role='tooltip'></span></div></button><div class='text-center mb-2'><a href='" +
					window.location.origin +
					"/index.php?route=product/category&path='  class='text-gray-900 text-underline'><small>View Product</small></a></div>"
			);
		const settings = {
			data: { $email: data },
		};
		$.ajax(settings).done(function (response) {
			_learnq.push(["track", "Offer Applied"]);
		});
	});
  const CookieService = {
    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + ";";
    },

    getCookie(name) {
      const cookies = document.cookie.split(";");

      for (const cookie of cookies) {
        if (cookie.indexOf(name + "=") > -1) {
          return cookie.split("=")[1];
        }
      }

      return null;
    },
  };

	if (CookieService.getCookie("offer-applied")) {
		let offerApplied = JSON.parse(
			CookieService.getCookie("offer-applied")
		);
		$(".offer-coupon")
		.parents(".popup-form")
		.html(
			"<label for='copy_textarea' tabindex='-1' class=''></label><button class='btn border offer-click bg-white coupon-click- p-2 w-100' data-offer-id='' data-clipboard-target='coupon_click_' onclick='offerClick(this);' id='btn_copy_' data-label='hp-coupon-click'><div class='d-flex justify-content-between position-relative'><h6 class='pl-2 mb-0' value='' id='coupon_click_'> FREE</h6><img src='catalog/view/theme/houseofworktops/image/offer_popup/copy-icon 2.svg' class='img-fluid'><span id='copy_tooltip' aria-live='assertive' role='tooltip'></span></div></button><div class='text-center mb-2'><a href='" +
				window.location.origin +
				"/index.php?route=product/category&path='  class='text-gray-900 text-underline'><small>View Product</small></a></div>"
		);
	}
  let field = $(".offer-email");
  let signUpButton = $(".btn-signup");
  field.on("input", function () {
    signUpButton.prop("disabled", false);
  });

  if (CookieService.getCookie("offer-claimed")) {
    let offerClaimed = JSON.parse(CookieService.getCookie("offer-claimed"));

    offerClaimed = offerClaimed.map((offer) => {
      let offer_id = offer ? offer.offer_id : null;
      let coupon_code = offer ? offer.coupon_code : null;
      let offer_category_id = offer ? offer.category_id : null;

      if (
        offer_id !== null &&
        coupon_code !== null &&
        offer_category_id !== null
      ) {
        $(".offer-panel-form-" + offer_id).html(
          "<label for='copy_textarea' tabindex='-1' class=''></label><button class='btn border bg-white offer-click p-2 w-100'  data-offer-id='" +
            offer_id +
            "' data-clipboard-target='coupon_click_" +
            offer_id +
            "' onclick='offerClick(this);' id='btn_copy_" +
            offer_id +
            "' data-label='hp-coupon-click'><div class='d-flex justify-content-between position-relative'><h6 class='pl-2 mb-0' value='' id='coupon_click_" +
            offer_id +
            "'>" +
            coupon_code +
            "</h6><img src='catalog/view/theme/houseofworktops/image/offer_popup/copy-icon 2.svg' class='img-fluid'><span id='copy_tooltip' aria-live='assertive' role='tooltip'></span></div></button><div class='text-center mb-2'><a href='" +
            window.location.origin +
            "/index.php?route=product/category&path=" +
            offer_category_id +
            "'  class='text-gray-900 text-underline'><small>View Product</small></a></div>"
        );
      }
    });
  }

  userData = JSON.parse(localStorage.getItem("userData")) || "no data";
});
//Close panels on Mobile nav
function closePanel() {
  $(".sidenav").removeClass("active");
  $(".overlay").removeClass("active");
  $("body").removeClass("no-scroll");
}

function getEmailPopupImpressions(emailPopupObj) {
  dataLayer.push({
    event: "emailpopupimpression",
    category: "userInteraction",
    action: "emailpopupimpression",
    label: emailPopupObj.label,
  });
}

function pushCouponCodetoDatalayer(couponObj) {
  dataLayer.push({
    event: "copiedCoupon",
    category: "userInteraction",
    action: "clickedCoupon",
    label: couponObj.name,
  });
}

function offerClick(element) {
  var copyButtonMessage = "Copied to Clipboard!";
  var dataOffer = $(element).data("offer-id");
  let copyText = $("#" + $(element).data("clipboard-target"));
  copyText.focus();
  copyText.text();
  navigator.clipboard.writeText(copyText.text());
  copyMessageTooltip(copyButtonMessage, dataOffer);
}

function copyMessageTooltip(copyButtonMessage, offer_id) {
  active = true;
  var copyButton = $("#btn_copy_" + offer_id);
  var tooltipVisibleTime = 2000; // How long to leave tooltip visible

  // tooltip
  let copyTooltip = $("#btn_copy_" + offer_id + " #copy_tooltip");
  // console.log(copyTooltip);
  copyTooltip.text(copyButtonMessage).addClass("active");
  copyButton.attr("aria-describedby", "copy_tooltip");
  var textArea = document.createElement("textarea");
  textArea.value = $("#coupon_click_" + offer_id).text();
  textArea.setAttribute("readonly", "");
  textArea.style = { position: "absolute", left: "-9999px" };
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);

  setTimeout(() => {
    copyTooltip.removeClass("active");
  }, tooltipVisibleTime);
}

// Cart add remove functions
var cart = {
  add: function (product_id, quantity) {
    $.ajax({
      url: "index.php?route=checkout/cart/add",
      type: "post",
      data:
        "product_id=" +
        product_id +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      beforeSend: function () {
        $("#cart > button").button("loading");
      },
      complete: function () {
        $("#cart > button").button("reset");
      },
      success: function (json) {
        $(".alert-dismissible, .text-danger").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        if (json["success"]) {
          $("#content")
            .parent()
            .before(
              '<div class="alert alert-success alert-dismissible"><i class="fa fa-check-circle"></i> ' +
                json["success"] +
                ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>'
            );

          // Need to set timeout otherwise it wont update the total
          setTimeout(function () {
            $("#cart > button").html(
              '<img src = "catalog/view/theme/houseofworktops/image/svg-icons/cart.svg" title = "{{ name }}" alt = "{{ name }}" class= "img-responsive mb-1" width = "20" loading = "lazy"/><div class="d-xl-inline" ><span class="px-1">Cart</span><span id="cart-total" class="badge badge-danger rounded-circle"> ' +
                json["total"] +
                "</span></div></span>"
            );
          }, 100);

          $("html, body").animate({ scrollTop: 0 }, "slow");

          $("#cart > ul").load("index.php?route=common/cart/info ul li");
          $("#nav-cart-mobile ul").load(
            "index.php?route=common/cart_menu/info ul li"
          );
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },
  update: function (key, quantity) {
    $.ajax({
      url: "index.php?route=checkout/cart/edit",
      type: "post",
      data:
        "key=" +
        key +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      beforeSend: function () {
        $("#cart > button").button("loading");
      },
      complete: function () {
        $("#cart > button").button("reset");
      },
      success: function (json) {
        // Need to set timeout otherwise it wont update the total
        setTimeout(function () {
          $("#cart > button").html(
            '<img src = "catalog/view/theme/houseofworktops/image/svg-icons/cart.svg" title = "{{ name }}" alt = "{{ name }}" class= "img-responsive mb-1" width = "20" loading = "lazy"/><div class="d-xl-inline" ><span class="px-1">Cart</span><span id="cart-total" class="badge badge-danger rounded-circle"> ' +
              json["total"] +
              "</span></div></span>"
          );
          $(".my-cart .cart-items").html("Items (" + json["total"] + ")");
        }, 100);

        if (
          getURLVar("route") == "checkout/cart" ||
          getURLVar("route") == "checkout/checkout"
        ) {
          location = "index.php?route=checkout/cart";
        } else {
          $("#cart > ul").load("index.php?route=common/cart/info ul li");
          $("#nav-cart-mobile ul").load(
            "index.php?route=common/cart_menu/info ul li"
          );
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },
  remove: function (key, name, ids, price, variant, quantity, store_id = 0) {
    $.ajax({
      url: "index.php?route=checkout/cart/remove",
      type: "post",
      data: "key=" + key,
      dataType: "json",
      beforeSend: function () {
        $("#cart > button").button("loading");
        dataLayer.push({
          event: "reset",
          ecommerce: undefined,
        });

        // var removedProducts = {{ecommerce.remove.products}};

        dataLayer.push({
          event: "removeFromCart",
          ecommerce: {
            remove: {
              // 'remove' actionFieldObject measures.
              products: [
                {
                  //  removing a product to a shopping cart.
                  name: name,
                  id: ids,
                  price: price.substring(1),
                  brand: "House of Worktops",
                  variant: variant,
                  quantity: quantity,
                },
              ],
            },
          },
        });
      },
      complete: function () {
        $("#cart > button").button("reset");
      },
      success: function (json) {
        json.flooring_sample_products.forEach(function (item) {
          $(`.button-sample[data-id=${item}]`).attr("disabled", false);
          $(`.button-sample[data-id=${item}]`)
            .find(".submit")
            .html("Add to cart");
          $(`.button-sample[data-id=${item}]`).removeAttr("title");
          $(`#button-cart-sample[data-id=${item}]`)
            .find(".submit")
            .html("Order Free Sample");
          $(`#order_sample[data-id=${item}]`).removeClass("d-none");
          if (json.product_ids) {
            if (json.product_ids.includes(item)) {
              $(`.button-sample[data-id=${item}]`).attr("disabled", true);
              $(`.button-sample[data-id=${item}]`)
                .find(".submit")
                .html("Added to cart");
              $(`.button-sample[data-id=${item}]`).attr(
                "title",
                "You have already added this sample"
              );
              $(`#button-cart-sample[data-id=${item}]`).attr(
                "title",
                "You have already added the sample of this product"
              );
              //$(`#button-cart-sample[data-id=${item}]`).find('.submit').html('Added sample to cart');
              $(`#order_sample[data-id=${item}]`).addClass("d-none");
            }
          }
        });
        // Need to set timeout otherwise it wont update the total
        setTimeout(function () {
          if (store_id == 0) {
            $("#cart > button").html(
              '<img src = "catalog/view/theme/houseofworktops/image/svg-icons/cart.svg" title = "{{ name }}" alt = "{{ name }}" class= "img-responsive mb-1" width = "20" loading = "lazy"/><div class="d-xl-inline" ><span class="px-1">Cart</span><span id="cart-total" class="badge badge-danger rounded-circle"> ' +
                json["total"] +
                "</span></div></span>"
            );
          } else {
            $("#cart > button").html(
              '<img src = "catalog/view/theme/howtradepartners/image/svg-icons/bag-white.svg" title = "{{ name }}" alt = "{{ name }}" class= "img-responsive mb-1 mr-1" width = "15" loading = "lazy"/><div class="d-xl-inline" ><span class="px-1 text-white">Cart</span><span id="cart-total" class="badge badge-danger rounded-circle"> ' +
                json["total"] +
                "</span></div></span>"
            );
          }
        }, 100);

        if (
          getURLVar("route") == "checkout/cart" ||
          getURLVar("route") == "checkout/checkout"
        ) {
          location = "index.php?route=checkout/cart";
        } else {
          $("#cart > ul").load("index.php?route=common/cart/info ul li");
          $("#nav-cart-mobile ul").load(
            "index.php?route=common/cart_menu/info ul li"
          );
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },
};

var voucher = {
  add: function () {},
  remove: function (key) {
    $.ajax({
      url: "index.php?route=checkout/cart/remove",
      type: "post",
      data: "key=" + key,
      dataType: "json",
      beforeSend: function () {
        $("#cart > button").button("loading");
      },
      complete: function () {
        $("#cart > button").button("reset");
      },
      success: function (json) {
        // Need to set timeout otherwise it wont update the total
        setTimeout(function () {
          $("#cart > button").html(
            '<img src = "catalog/view/theme/houseofworktops/image/svg-icons/cart.svg" title = "{{ name }}" alt = "{{ name }}" class= "img-responsive mb-1" width = "20" loading = "lazy"/><div class="d-xl-inline" ><span class="px-1">Cart</span><span id="cart-total" class="badge badge-danger rounded-circle"> ' +
              json["total"] +
              "</span></div></span>"
          );
        }, 100);

        if (
          getURLVar("route") == "checkout/cart" ||
          getURLVar("route") == "checkout/checkout"
        ) {
          location = "index.php?route=checkout/cart";
        } else {
          $("#cart > ul").load("index.php?route=common/cart/info ul li");
          $("#nav-cart-mobile ul").load(
            "index.php?route=common/cart_menu/info ul li"
          );
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },
};

var wishlist = {
  add: function (product_id) {
    $.ajax({
      url: "index.php?route=account/wishlist/add",
      type: "post",
      data: "product_id=" + product_id,
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        if (json["success"]) {
          $("#content")
            .parent()
            .before(
              '<div class="alert alert-success alert-dismissible"><i class="fa fa-check-circle"></i> ' +
                json["success"] +
                ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>'
            );
        }

        $("#wishlist-total span").html(json["total"]);
        $("#wishlist-total").attr("title", json["total"]);

        $("html, body").animate({ scrollTop: 0 }, "slow");
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },
  remove: function () {},
};

var compare = {
  add: function (product_id) {
    $.ajax({
      url: "index.php?route=product/compare/add",
      type: "post",
      data: "product_id=" + product_id,
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible").remove();

        if (json["success"]) {
          $("#content")
            .parent()
            .before(
              '<div class="alert alert-success alert-dismissible"><i class="fa fa-check-circle"></i> ' +
                json["success"] +
                ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>'
            );

          $("#compare-total").html(json["total"]);

          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },
  remove: function () {},
};

/* Agree to Terms */
$(document).delegate(".agree", "click", function (e) {
  e.preventDefault();

  $("#modal-agree").remove();

  var element = this;

  $.ajax({
    url: $(element).attr("href"),
    type: "get",
    dataType: "html",
    success: function (data) {
      html = '<div id="modal-agree" class="modal">';
      html +=
        '  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <h4 class="modal-title">' + $(element).text() + "</h4>";
      html +=
        '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += "      </div>";
      html += '      <div class="modal-body">' + data + "</div>";
      html += "    </div>";
      html += "  </div>";
      html += "</div>";

      $("body").append(html);

      $("#modal-agree").modal("show");
    },
  });
});

// Autocomplete */
(function ($) {
  $.fn.autocomplete = function (option) {
    return this.each(function () {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      $(this).attr("autocomplete", "off");

      // Focus
      $(this).on("focus", function () {
        this.request();
      });

      // Blur
      $(this).on("blur", function () {
        setTimeout(
          function (object) {
            object.hide();
          },
          200,
          this
        );
      });

      // Keydown
      $(this).on("keydown", function (event) {
        switch (event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

      // Click
      this.click = function (event) {
        event.preventDefault();

        value = $(event.target).parent().attr("data-value");

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      };

      // Show
      this.show = function () {
        var pos = $(this).position();

        $(this)
          .siblings("ul.dropdown-menu")
          .css({
            top: pos.top + $(this).outerHeight(),
            left: pos.left,
          });

        $(this).siblings("ul.dropdown-menu").show();
      };

      // Hide
      this.hide = function () {
        $(this).siblings("ul.dropdown-menu").hide();
      };

      // Request
      this.request = function () {
        clearTimeout(this.timer);

        this.timer = setTimeout(
          function (object) {
            object.source($(object).val(), $.proxy(object.response, object));
          },
          200,
          this
        );
      };

      // Response
      this.response = function (json) {
        html = "";

        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]["value"]] = json[i];
          }

          for (i = 0; i < json.length; i++) {
            if (!json[i]["category"]) {
              html +=
                '<li data-value="' +
                json[i]["value"] +
                '"><a href="#">' +
                json[i]["label"] +
                "</a></li>";
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (i = 0; i < json.length; i++) {
            if (json[i]["category"]) {
              if (!category[json[i]["category"]]) {
                category[json[i]["category"]] = new Array();
                category[json[i]["category"]]["name"] = json[i]["category"];
                category[json[i]["category"]]["item"] = new Array();
              }

              category[json[i]["category"]]["item"].push(json[i]);
            }
          }

          for (i in category) {
            html +=
              '<li class="dropdown-header">' + category[i]["name"] + "</li>";

            for (j = 0; j < category[i]["item"].length; j++) {
              html +=
                '<li data-value="' +
                category[i]["item"][j]["value"] +
                '"><a href="#">&nbsp;&nbsp;&nbsp;' +
                category[i]["item"][j]["label"] +
                "</a></li>";
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        $(this).siblings("ul.dropdown-menu").html(html);
      };

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this)
        .siblings("ul.dropdown-menu")
        .delegate("a", "click", $.proxy(this.click, this));
    });
  };
})(window.jQuery);

// Countdown Logic
$(document).ready(function () {
  function getTimeRemaining(endtime, timezone = 'UTC') {
      // Get current time in the specified timezone
      const now = new Date();
      const options = { timeZone: timezone };
      const regionTime = new Date(now.toLocaleString('en-US', options));
      
      // Calculate time difference
      const total = Date.parse(endtime) - regionTime.getTime();
      
      // Convert to time units
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
          total,
          days,
          hours,
          minutes,
          seconds,
          currentTime: regionTime
      };
  }

  function initializeClock() {
    var clock = $(".timer");
    var daysSpan = clock.find(".days");
    var hoursSpan = clock.find(".hours");
    var minutesSpan = clock.find(".minutes");
    var secondsSpan = clock.find(".seconds");

    function updateClock() {
      const t = getTimeRemaining(clock.data("timer"));

      daysSpan.html(t.days);
      hoursSpan.html(("0" + t.hours).slice(-2));
      minutesSpan.html(("0" + t.minutes).slice(-2));
      secondsSpan.html(("0" + t.seconds).slice(-2));

      if (t.days <= 1) {
        clock.find(".days").siblings().text("Day");
      }
      if (t.hours <= 1) {
        clock.find(".hours").siblings().text("Hour");
      }
      if (t.minutes <= 1) {
        clock.find(".minutes").siblings().text("Min");
      }

      if (t.total <= 0) {
        clearInterval(timeinterval);
        //hiding code goes here
        clock.parent().hide();
        $("#sweet-sale,.timer").hide();
      }
    }
    const timeinterval = setInterval(updateClock, 1000);
    updateClock();
  }

  initializeClock();
});

$(document).ready(function() {
    if ($('#product-product').length > 0) {
        window._conv_page_type = 'Product_Page';
    } else if ($('#product-category').length > 0) {
        window._conv_page_type = 'Product_Category';
    } else {
        window._conv_page_type = 'Other_Page'; 
    }
});
